// @noflow
import React, { useEffect, useState, useContext } from 'react';
import { Box } from '@latitude/box';
import { Text } from '@latitude/text';
import {
  ALIGN,
  MARGIN,
  COLOR,
  FONT_WEIGHT
} from '@latitude/core/utils/constants';
import { Heading5 } from '@latitude/heading';
// import { CurrencyInput } from '@latitude/currency-input';
// import { Link } from '../Link/Link';
import CurrencyInput from '../CurrencyInput/CurrencyInputKb';
import ConfettiText from '../ConfettiText/ConfettiTextKb';
import SoftQuoteContext from '../../context/SoftQuoteContext';
import { SOFT_QUOTE_KIWIBANK_URL } from '../../utils/softQuoteUtil';
import {
  REPAYMENT_PERIOD_NZ_OPTIONS,
  AMOUNT_MIN_ERROR_MESSAGE,
  AMOUNT_MAX_ERROR_MESSAGE
} from './constants';
import {
  LOAN_PURPOSE,
  CL_DEFAULT_LOAN_TERM,
  PL_MINIMUM_AMOUNT,
  PL_MAXIMUM_AMOUNT
} from '../../utils/constants';
import {
  MainContentKiwibank,
  FormFields,
  BorrowAmountFieldKb,
  RepaymentPeriodFieldKb,
  StyledSelectKb,
  // CheckEligibilityButton,
  FooterKiwibank
} from './EstimateRateWidget.styled';

interface Props {
  defaultPurpose?: string;
  defaultPurposeOther?: string;
  defaultLoanAmount?: number;
  defaultRepaymentPeriod?: number;
  trackProductId?: Array<string>;
}

const EstimateRateWidget = (props: Props) => {
  const {
    defaultPurpose,
    defaultPurposeOther,
    defaultLoanAmount,
    defaultRepaymentPeriod,
    // trackProductId
  } = props;

  const [purpose] = useState(defaultPurpose);
  const [purposeOther] = useState(defaultPurposeOther);
  const [loanAmount, setLoanAmount] = useState(defaultLoanAmount);
  const [repaymentPeriod, setRepaymentPeriod] = useState(defaultRepaymentPeriod);
  // const [loanPurposeMoreInfoModalOpen, setLoanPurposeMoreInfoModalOpen] = useState(false);

  /* Purpose error message state */
  // const [hasPurposeError, setHasPurposeError] = useState(false);

  /* Loan Amount error message state */
  const [hasAmountError, setHasAmountError] = useState(false);
  const [amountErrorMessage, setAmountErrorMessage] = useState('');

  /* soft quote redirect url context */
  const { setApplyUrl } = useContext(SoftQuoteContext);
  const updateRedirectKiwibankUrl = () => {
    const purposeOtherText =
      purpose === LOAN_PURPOSE.OTHER ? `&other=${purposeOther}` : '';
    const url = `${SOFT_QUOTE_KIWIBANK_URL}?amount=${loanAmount}&purpose=${purpose}&period=${repaymentPeriod}${purposeOtherText}`;
    setApplyUrl(url);
  };

  useEffect(() => {
    updateRedirectKiwibankUrl();
  }, [purpose, loanAmount, purposeOther, repaymentPeriod]);

  useEffect(() => {
    if (!loanAmount || loanAmount < PL_MINIMUM_AMOUNT) {
      setHasAmountError(true);
      setAmountErrorMessage(AMOUNT_MIN_ERROR_MESSAGE);
    } else if (loanAmount > PL_MAXIMUM_AMOUNT) {
      setHasAmountError(true);
      setAmountErrorMessage(AMOUNT_MAX_ERROR_MESSAGE);
    } else {
      setHasAmountError(false);
      setAmountErrorMessage('');
    }
  }, [loanAmount]);

  return (
    <Box id='estimate-rate-widget-box'>
      <MainContentKiwibank>
        <Heading5
          align={ALIGN.CENTER}
          fontWeight={FONT_WEIGHT.BOLD}
          color={COLOR.BLACK}
        >
          Check your eligibility
        </Heading5>
        <Text align={ALIGN.CENTER} marginBottom={MARGIN.M16}>
          We&apos;ll ask you a few quick questions about your circumstances to help you check your eligibility.
        </Text>

        <FormFields>
          <BorrowAmountFieldKb>
            <Box className="mb-4">
              <CurrencyInput
                widget
                labelText="I'd like to borrow"
                name="currency-input-story"
                maxLength={10}
                prefix="$"
                value={loanAmount}
                onValueChange={e => {
                  setLoanAmount(e.value);
                }}
                showErrorMessage={amountErrorMessage}
                showError={hasAmountError}
              />
            </Box>
          </BorrowAmountFieldKb>
          &nbsp;&nbsp;
          <RepaymentPeriodFieldKb>
            <Box className="mb-4">
              <StyledSelectKb
                widget
                label="Over a period of"
                selectedValue={repaymentPeriod}
                values={REPAYMENT_PERIOD_NZ_OPTIONS}
                onChange={e => {
                  setRepaymentPeriod(e.target.value);
                }}
              />
            </Box>
          </RepaymentPeriodFieldKb>
          {/* <CheckEligibilityButton
            id="getStartedButton"
            className="mx-auto"
            button="primary"
            href={applyUrl}
            target="_self"
            trackId="estimate-rate-get-started"
            trackEventData={{
              category: 'cta',
              action: 'quote-link',
              location: 'Check your eligibility'
            }}
            trackProductId={trackProductId}
          >
            Check your eligibility
          </CheckEligibilityButton> */}
        </FormFields>

        <Box marginTop={MARGIN.M16}>
          <ConfettiText
            text="This won't affect your Credit Score"
            backgroundColor={COLOR.TRANSPARENT}
          />
        </Box>
      </MainContentKiwibank>

      <FooterKiwibank>
        <Text align={ALIGN.CENTER}>
          We&apos;ll ask you a few quick questions about your circumstances to help you check your eligibility&nbsp;
          {/* <Link
            href={SOFT_QUOTE_KIWIBANK_URL}
            target="_self"
            data-trackid="check-your-rate-retrieve-your-rate"
            trackEventData={{
              category: 'cta',
              action: 'quote-retrieval-link',
              location: 'Check your eligibility'
            }}
            trackProductId={trackProductId}
          >
            here
          </Link> */}
        </Text>
      </FooterKiwibank>
    </Box>
  );
};

const defaultProps = {
  defaultPurpose: LOAN_PURPOSE.SELECT_PURPOSE,
  defaultPurposeOther: '',
  defaultLoanAmount: PL_MINIMUM_AMOUNT,
  defaultRepaymentPeriod: CL_DEFAULT_LOAN_TERM,
  trackProductId: []
};

EstimateRateWidget.defaultProps = defaultProps;

export default EstimateRateWidget;
